export const HEADER_ITEMS = {
  BACK_BUTTON: 'back',
  SIDEBAR: 'sidebar',
  TAPSI_LOGO: 'logo',
} as const;
